<template>
  <div class="page-view box-card">

    <div class="box-card-header">
      <router-link class="kg-btn1" :to="{ name: 'proxyTransferRecord' }">
        <I18Lang id="my28" defaultText="转账记录" />
      </router-link>
    </div>

    <div class="box-card-content">
      <el-form :model="formData" ref="formData" class="reset-from" :rules="rules">

        <el-form-item label="转账ID" prop="account_id">
          <template slot="label">
            <I18Lang id="my148" defaultText="转账ID" />
          </template>
          <el-input @input="accountInput" class="reset-input" v-model="formData.account_id"
            :placeholder="$t('my148')"></el-input>
          <div class="recipient-id-error" v-if="recipientIdError">{{ recipientIdError }}</div>
        </el-form-item>

        <div class="form-item" v-if="transferUserInfo.username">
          <div class="form-item-label">
            <I18Lang id="my149" defaultText="转账对象姓名" />
          </div>
          <div class="form-item-value">{{ transferUserInfo.username }}</div>
        </div>

        <div class="form-item">
          <div class="form-item-label">
            <I18Lang id="my37" defaultText="现金账户($)" />
          </div>
          <div class="form-item-value">{{ transferInfo.balance }}</div>
        </div>

        <el-form-item label="转账金额($)" prop="amount">
          <template slot="label">
            <I18Lang id="my68" defaultText="转账金额($)" />
          </template>
          <el-input type="number" class="reset-input" v-model="formData.amount"
            :placeholder="$t('proxymoney111')"></el-input>
        </el-form-item>

        <el-form-item>
          <div :loading="isSubmitLoading" class="btn-submit kg-btn2" @click="submitForm('formData')">
            <I18Lang id="my65" defaultText="立即提交" />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'home',
  data () {
    return {
      fileDomain,
      isSubmitLoading: false,
      transferInfo: {}, // 转账信息
      transferUserInfo: {}, // 转账信息
      recipientIdError: '',
      isRecipientValid: false,
      formData: {
        account_id: '',
        amount: ''
      },
      rules: {
        account_id: [{ required: true, message: this.$t('my150'), trigger: 'blur' }],
        amount: [{ required: true, message: this.$t('usermoney43'), trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getTransferInfo()
  },
  methods: {
    accountInput (val) {
      this.transferUserInfo = {}
      this.recipientIdError = ''
      this.isRecipientValid = false
      const accountId = String(val || '').trim()
      if (!accountId) return
      this.checkRecipientIdDebounced(accountId)
    },
    checkRecipientIdDebounced: _.debounce(function (accountId) {
      this.checkRecipientId(accountId)
    }, 600),
    checkRecipientId (accountId) {
      const currentAccountId = String(this.formData.account_id || '').trim()
      if (!accountId || accountId !== currentAccountId) return
      this.$http.post('/api/viewUsername', { account_id: accountId }, {
        direct: true,
        loading: false
      }).then(response => {
        if (accountId !== String(this.formData.account_id || '').trim()) return
        const isSuccess = response && Number(response.code) === 200 && response.data
        if (isSuccess) {
          this.transferUserInfo = response.data
          this.isRecipientValid = true
          this.recipientIdError = ''
        } else {
          this.transferUserInfo = {}
          this.isRecipientValid = false
          this.recipientIdError = this.$t('proxytransfer1')
        }
      }).catch(() => {
        if (accountId !== String(this.formData.account_id || '').trim()) return
        this.transferUserInfo = {}
        this.isRecipientValid = false
        this.recipientIdError = this.$t('proxytransfer1')
      })
    },
    getTransferInfo () { // 获取转账信息
      this.$http.post('/api/cash/balance').then(result => {
        this.transferInfo = result
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return

        if (!this.isRecipientValid) {
          this.recipientIdError = this.$t('proxytransfer1')
          return
        }

        if (Number(this.formData.amount || 0) > Number(this.transferInfo.balance || 0)) {
          this.$alert(this.$t('transferbalance1'), {
            confirmButtonText: this.$t('my25'),
            center: true,
            customClass: 'warning-alert'
          })
          return
        }

        this.submit()
      })
    },
    submit () { // 提交
      this.isSubmitLoading = true
      this.$http.post('/api/cash/agentTransfer', this.formData).then(result => {
        this.$alert(`<h3>${this.$t('my76')}</h3>`, '', {
          confirmButtonText: this.$t('my77'),
          // cancelButtonText: this.$t('public28'),
          customClass: 'success-alert',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$router.push({ name: 'proxyTransferRecord' })
        }).catch(() => {
        })
        this.isSubmitLoading = false
      }).catch(() => {
        this.isSubmitLoading = false
      })
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url('../../../../assets/img/k.png') no-repeat center / 100%;
    width: 936px;
    height: 640px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    padding-top: 88px;

    .reset-from {

      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01B2F5;
        }

        .form-item-value {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }

      .recipient-id-error {
        width: 319px;
        margin-top: 6px;
        color: #F56C6C;
        font-size: 13px;
        line-height: 18px;
      }

      ::v-deep .el-form-item {
        margin-bottom: 40px;

        .el-form-item__label {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #01B2F5;
        }

        .el-input__inner {
          width: 319px;
          height: 34px;
          border: 1px solid rgba(1, 178, 245, 0.5);
          line-height: 34px;
          background: transparent;
          color: #fff;
          border-radius: 0;
        }

      }

      .btn-submit {
        width: 110px;
        height: 55px;
        line-height: 55px;
        margin-left: -10px;
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 238px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      height: auto;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      padding-top: 88px;

      .reset-from {

        .form-item {
          margin-bottom: 35px;

          .form-item-label {
            font-size: 20px;
            font-weight: 400;
            color: #01B2F5;
          }

          .form-item-value {
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
          }
        }

        ::v-deep .el-form-item {
          margin-bottom: 40px;

          .el-form-item__label {
            font-size: 20px;
            font-family: Arial;
            font-weight: 400;
            color: #01B2F5;
          }

          .el-input__inner {
            width: 329px;
            height: 60px;
            font-size: 18px;
            border: 1px solid rgba(1, 178, 245, 0.5);
            line-height: 60px;
            background: transparent;
            color: #fff;
            border-radius: 0;
          }

          .el-form-item__error {
            font-size: 16px;
          }
        }

        .btn-submit {
          width: 210px;
          height: 85px;
          line-height: 85px;
          font-size: 20px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}

.page-view ::v-deep .recipient-id-error {
  width: 319px;
  margin-top: 6px;
  color: #F56C6C;
  font-size: 13px;
  line-height: 18px;
}
</style>
